import React, { Component } from "react";
import { connect } from "react-redux";
import {
  CarregamentoInteractions,
  GetHistory,
  dbfileSize,
  InteracoesContactNumber,
  GetInteractionsContact,
  GetPhoneMidia,
  SearchingHistoryData,
} from "../actions";
import { Tooltip, Popover, Topover, Tooltippy } from "../actions/Tippy";
import ReactDOM from "react-dom";
import WHATSAPP from "../build/images/t-whatsapp.svg";
import MicroModal from "micromodal";
import ICONPDFEXPORT from "../build/images/pdf.svg";
import Moment from "moment";
import VIDEO from "../build/images/video.jpg";
import AUDIO from "../build/images/audio.svg";
import FOTO from "../build/images/foto.svg";
import DOC from "../build/images/doc.svg";
import Highlighter from "react-highlight-words";
import AVI from "../build/images/avi-file.png";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import PdfDocument from "../components/templates/PdfDocument";
import latinize from "latinize";
import JPG from "../build/images/jpg-file.png";
import XLS from "../build/images/media-icon.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import Lightbox from "react-image-lightbox";
import WEBCHATICON from "../build/images/webchat-new.svg";
import TWITTER from "../build/images/twitter-new.svg";
import MIDIAFACE from "../build/images/facebook_new.svg";
import MIDIAZAP from "../build/images/whatsapp_new.svg";
import GOOGLEGBM from "../build/images/googlegbm-new.svg";
import TEAMS from "../build/images/channels/teamsMedium.svg";
import { ReactComponent as SMSICON } from "../build/images/sms-new.svg";
import MIDIAEMAIL from "../build/images/email-new.svg";
import MIDIAWEB from "../build/images/webchat-new.svg";
import CALLCHAT from "../build/images/callchat-new.svg";
import TELEGRAM from "../build/images/channels/telegram.svg";
import MIDIATELEGRAM from "../build/images/telegram-new.svg";
import LINKEDIN from "../build/images/linkedin-new.svg";
import INSTAGRAM from "../build/images/instagram_new.svg";

const { connection_platform } = require("../services/api");
const { meses } = require("../services/data");

var gethostname = window.location.hostname;
var pathname = "";
var checkreply = false;

var iplocal = connection_platform.ip_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

function isJson(item) {
  item = typeof item != "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item != null) {
    return true;
  }

  return false;
}

function tratarMSG(item) {
  var mensagem_tratada = item;
  mensagem_tratada = item.replace(/¿/gi, "\n");
  mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/"/gi, "");
    mensagem_tratada = mensagem_tratada.replace(
      /[^A-ZÀ-Ú a-zà-ú 0-9 , . ? ! *  # ; : '-' _ + § ¿ { } ' " ª \\ \ ]/g,
      ""
    );
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    try {
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
      mensagem_tratada = mensagem_tratada.replace(/ªª/gi, "\r\n");
    } catch (e) {
      mensagem_tratada = item;
    }
  }
  return mensagem_tratada;
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const mapStateToProps = (state) => {
  return {
    IPCurrent: state.ipcurrent,
    InteractionsNumber: state.interactions,
    InfoUsers: state.informationusers,
    History: state.history,
    Contact: state.atendimento,
  };
};

const mapDispatchToProps = (dispatch) => ({
  CarregamentoCDR: (cdrid, idgroup) => {
    dispatch(GetHistory([]));
    CarregamentoInteractions(cdrid, idgroup)(dispatch);
  },
  InteracoesContactNumber: (number, datainit, datafim, mensagem, idgroup) => {
    dispatch(
      InteracoesContactNumber(number, datainit, datafim, mensagem, idgroup)
    );
    dispatch(GetInteractionsContact([]));
    dispatch(GetPhoneMidia([]));
  },
  SearchingHistory: (histstart, histend, cdrid, telefone, idgroup) => {
    dispatch(
      SearchingHistoryData(histstart, histend, cdrid, telefone, idgroup)
    );
  },
});

class InteractionsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      interactions: [],
      searchText: "",
      history: [],
      dateinit: props.dateinit,
      dateend: props.dateend,
      mensagem: "",
    };
    this.SearchHistoryContact = this.SearchHistoryContact.bind(this);
  }

  SearchHistoryContact(numeroCliente) {
    let histstart = this.datahistoryinitinteract.value;
    let histend = this.datahistoryfiminteract.value;
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.SearchingHistory(histstart, histend, 33, numeroCliente, idgroup);
    this.setState({ dateinit: histstart + "T00:00" });
    this.setState({ dateend: histend + "T23:59" });
  }

  ExitModal(e, modal) {
    MicroModal.close(modal);
  }

  ShowHistory(e, idcdr, data) {
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.CarregamentoCDR(idcdr, idgroup);
    MicroModal.close("modal__agenda-pf__cliente__interacoes__duplicado");
    MicroModal.show("modal__historico-atendimento-contact-2");
    this.datahistoryinitinteract.value = data + "T00:00";
    this.datahistoryfiminteract.value = data + "T23:59";
    this.setState({ dateinit: data + "T00:00" });
    this.setState({ dateend: data + "T23:59" });
  }

  SearchInHistoryContact(e) {
    e.preventDefault();
    this.setState({ showHistory: !this.state.showHistory });
  }

  CloseHistory(e) {
    MicroModal.close("modal__historico-atendimento-contact-2");
    MicroModal.show("modal__agenda-pf__cliente__interacoes__duplicado");
  }

  GetInteractions(e, number) {
    e.preventDefault();
    let datainit = this.datetimeinit.value;
    let datafim = this.datetimeend.value;
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.InteracoesContactNumber(
      number.substr(2),
      datainit,
      datafim,
      this.state.mensagem,
      idgroup
    );
  }

  render() {
    const {
      Contact,
      InfoUsers,
      InteractionsNumber,
      History,
      displayscreen,
      monitorclient,
    } = this.props;
    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);

    var ContactId = Contact;

    if (displayscreen == "monitoring") {
      ContactId = monitorclient;
    }

    if (InteractionsNumber.length != 0) {
      this.state.interactions = InteractionsNumber.interactions;
    }

    if (History.length) {
      this.state.history = History;
    } else {
      this.state.history = [];
    }

    const agora = Moment().subtract(7, "days");
    this.datetimeinit = agora.format("YYYY-MM-DDT00:00");
    this.datetimeend = Moment().format("YYYY-MM-DDT23:59");

    var dia = "";
    var mes = "";
    var ano = "";
    var auxdia = "";

    return (
      <>
        <div
          className="modal micromodal-slide"
          id="modal__agenda-pf__cliente__interacoes__duplicado"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda-pf__cliente__interacoes__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__agenda-pf__cliente__interacoes__title"
                >
                  Interações
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  onClick={(event) =>
                    this.ExitModal(event, "pf__cliente__interacoes_history")
                  }
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__agenda-pf__cliente__interacoes__content"
              >
                <div className="modal__content__user-details__header">
                  <div className="modal__content__user-details__header__info">
                    <div className="modal__content__user-details__header__info__photo">
                      person
                    </div>
                    <div className="modal__content__user-details__header__info__text">
                      <div className="modal__content__user-details__header__info__name">
                        {createJSON(ContactId.cliente)}
                      </div>
                      <div className="modal__content__user-details__header__info__phone">
                        {ContactId.telefone}
                      </div>
                    </div>
                  </div>
                  <div className="modal__content__user-details__header__search">
                    <div className="modal__content__user-details__header__search__title">
                      Deseja buscar as interações de qual período?
                    </div>
                    <a className="modal__content__user-details__header__search__form">
                      <div className="modal__content__user-details__header__search__form__col modal__content__user-details__header__search__form__col--half">
                        <label
                          htmlFor="modal__content__user-details__header__search__form__de"
                          className="modal__content__user-details__header__search__form__col__label"
                        >
                          De:
                        </label>
                        <input
                          type="datetime-local"
                          defaultValue={this.datetimeinit}
                          ref={(input) => (this.datetimeinit = input)}
                          className="modal__content__user-details__header__search__form__col__input"
                          id="modal__content__user-details__header__search__form__de"
                        />
                      </div>
                      <div className="modal__content__user-details__header__search__form__col modal__content__user-details__header__search__form__col--half">
                        <label
                          htmlFor="modal__content__user-details__header__search__form__ate"
                          className="modal__content__user-details__header__search__form__col__label"
                        >
                          Até:
                        </label>
                        <input
                          type="datetime-local"
                          defaultValue={this.datetimeend}
                          ref={(input) => (this.datetimeend = input)}
                          className="modal__content__user-details__header__search__form__col__input"
                          id="modal__content__user-details__header__search__form__ate"
                        />
                      </div>

                      <div className="block-header__search-box-nav">
                        <div className="block-header__search-box-content-input">
                          <input
                            type="text"
                            placeholder="Pesquisar mensagens..."
                            onChange={(e) =>
                              this.setState({ mensagem: e.target.value })
                            }
                            className="block-header__search-box-input"
                          />
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={(event) =>
                          this.GetInteractions(event, ContactId.telefone)
                        }
                        className="modal__content__form__group__button"
                      >
                        Buscar
                      </button>
                    </a>
                  </div>
                </div>
                <div className="modal__content__user-details__content">
                  <div className="modal__content__tabs__body__tab__result">
                    <div className="modal__content__tabs__body__tab__result__header modal__content__tabs__body__tab__result__header--interacao">
                      <div className="modal__content__tabs__body__tab__result__header__col">
                        Canal
                      </div>
                      <div className="modal__content__tabs__body__tab__result__header__col"></div>
                      <div className="modal__content__tabs__body__tab__result__header__col">
                        Operador
                      </div>
                      <div className="modal__content__tabs__body__tab__result__header__col ">
                        Criticidade
                      </div>
                      <div className="modal__content__tabs__body__tab__result__header__col ">
                        Data e Hora
                      </div>
                      <div className="modal__content__tabs__body__tab__result__header__col"></div>
                    </div>
                    <div className="modal__content__tabs__body__tab__result__body">
                      {this.state.interactions.map((interaction, index) => (
                        <>
                          <Tooltippy
                            content={
                              interaction.subservico !== null
                                ? interaction.subservico
                                : "Saída"
                            }
                          >
                            <div className="modal__content__tabs__body__tab__result__body__row modal__content__tabs__body__tab__result__body__row--interacao">
                              <div className="modal__content__tabs__body__tab__result__body__col ">
                                {(() => {
                                  if (interaction.idmidia === 1) {
                                    return (
                                      <img
                                        src={CALLCHAT}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />

                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M0,0H20V20H0Z" fill="none"/><path  className="grey-mode" d="M18.82,14.632A10.572,10.572,0,0,1,15.5,14.1a.95.95,0,0,0-.95.223L12.5,16.372a14,14,0,0,1-6.133-6.133L8.416,8.178a.893.893,0,0,0,.232-.931,10.572,10.572,0,0,1-.531-3.322A.933.933,0,0,0,7.188,3H3.924A.933.933,0,0,0,3,3.931a15.819,15.819,0,0,0,15.822,15.82.933.933,0,0,0,.929-.931V15.556A.933.933,0,0,0,18.82,14.632Zm-.931-3.264h1.86A8.376,8.376,0,0,0,11.375,3V4.86a6.509,6.509,0,0,1,6.514,6.514Zm-3.723,0h1.86a4.655,4.655,0,0,0-4.652-4.645v1.86a2.788,2.788,0,0,1,2.792,2.792Z" transform="translate(-1.375 -1.375)" fill="#005daa"/></svg>
                                    );
                                  } else if (interaction.idmidia === 2) {
                                    return (
                                      <img
                                        src={MIDIAWEB}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                    );
                                  } else if (interaction.idmidia === 6) {
                                    return (
                                      <img
                                        src={INSTAGRAM}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />

                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.009" viewBox="0 0 20 20.009"><path d="M0,.961V19.047a.961.961,0,0,0,.961.961h9.693V12.283h-2.6V9.126h2.6V6.475a3.49,3.49,0,0,1,3.49-3.49h2.722V5.821H14.917a1.112,1.112,0,0,0-1.111,1.111V9.126h3.007L16.4,12.283H13.8v7.726h5.237A.961.961,0,0,0,20,19.047V.961A.961.961,0,0,0,19.039,0H.953A.959.959,0,0,0,0,.961Z" fill="#3b5998"  className="grey-mode"/></svg>
                                    );
                                  } else if (interaction.idmidia === 5) {
                                    return (
                                      <img
                                        src={MIDIAZAP}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                    );
                                  } else if (interaction.idmidia === 3) {
                                    return (
                                      <img
                                        src={MIDIAEMAIL}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                    );
                                  } else if (interaction.idmidia === 4) {
                                    return (
                                      <img
                                        src={MIDIAFACE}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                    );
                                  } else if (interaction.idmidia === 8) {
                                    return (
                                      <img
                                        src={MIDIATELEGRAM}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                    );
                                  } else if (interaction.idmidia === 9) {
                                    return (
                                      <img
                                        src={TWITTER}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                    );
                                  } else if (interaction.idmidia === 10) {
                                    return (
                                      <img
                                        src={LINKEDIN}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                    );
                                  } else if (interaction.idmidia === 11) {
                                    return (
                                      <img
                                        src={GOOGLEGBM}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                    );
                                  } else if (interaction.idmidia === 12) {
                                    return (
                                      <div>
                                        <SMSICON />
                                      </div>
                                    );
                                  } else if (interaction.idmidia === 15) {
                                    return (
                                      <img
                                        src={TEAMS}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                    );
                                  }
                                })()}
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col ">
                                {(() => {
                                  if (interaction.idmidia === 1) {
                                    return "Chamada de Voz";
                                  } else if (
                                    interaction.mensagem === null ||
                                    interaction.mensagem === "" ||
                                    interaction.mensagem === ""
                                  ) {
                                    return "Sem mensagem de texto";
                                  } else {
                                    if (isJson(interaction.mensagem) === true) {
                                      let json = JSON.parse(
                                        interaction.mensagem
                                      );
                                      let options = json.options;
                                      let i = 1;
                                      var opcoes = [];
                                      for (i in options) {
                                        opcoes.push(i + " - " + options[i][1]);
                                      }
                                      return json.msg + " \r\n ";
                                    } else {
                                      var mensagem_tratada =
                                        interaction.mensagem;
                                      let valor = 1;
                                      try {
                                        mensagem_tratada =
                                          '{"' +
                                          valor +
                                          '": [{"mensagem_tratada":"' +
                                          mensagem_tratada +
                                          '"}]}';
                                        var obj = JSON.parse(mensagem_tratada);
                                        mensagem_tratada =
                                          obj[1][0].mensagem_tratada;
                                      } catch (e) {
                                        mensagem_tratada = interaction.mensagem;
                                      }
                                      return mensagem_tratada;
                                    }
                                  }
                                })()}
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col ">
                                {interaction.username}
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col ">
                                <div
                                  className="criticidade normal"
                                  data-tippy="Normal"
                                  tabIndex="0"
                                >
                                  •
                                </div>
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col  ">
                                {interaction.datarec}
                              </div>

                              {(() => {
                                if (interaction.idmidia === 1) {
                                  var url = interaction.filerecord;
                                  var name = "Sem arquivo";
                                  var namefile;
                                  if (url) {
                                    url = url.replace(
                                      "192.168.178.2",
                                      "\\" + interaction.change_path
                                    );
                                    namefile = url
                                      .split("\\")
                                      .pop()
                                      .split("#")[0]
                                      .split("?")[0];
                                  }

                                  return (() => {
                                    if (InfoUsers.permreproduce === true) {
                                      return (
                                        <div className="modal__content__tabs__body__tab__result__body__col  ">
                                          <div className="modal__content__tabs__body__tab__result__body__actions modal__content__tabs__body__tab__result__body__actions--audio">
                                            <div className="actions-media">
                                              <audio
                                                src={
                                                  connection_platform.type_connect +
                                                  "://" +
                                                  ipcurrent +
                                                  url
                                                }
                                                controls="controls"
                                                controlslist="nofullscreen nodownload noremoteplayback foobar"
                                                className="actions-media__audio"
                                              ></audio>
                                              {/* <a className="download-media" href={connection_platform.type_connect+'://'+ipcurrent+url} download><i className="material-icons">get_app</i></a> */}
                                              {(() => {
                                                if (
                                                  InfoUsers.permdownload ===
                                                  true
                                                ) {
                                                  return (
                                                    <a
                                                      className="download-media"
                                                      onClick={(event) =>
                                                        this.download(
                                                          connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            url,
                                                          namefile
                                                        )
                                                      }
                                                    >
                                                      <i className="material-icons">
                                                        get_app
                                                      </i>
                                                    </a>
                                                  );
                                                }
                                              })()}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })();
                                } else {
                                  return (
                                    <div className="modal__content__tabs__body__tab__result__body__col  ">
                                      <div className="modal__content__tabs__body__tab__result__body__col  modal__content__tabs__body__tab__result__body__col--end">
                                        <div className="modal__content__tabs__body__tab__result__body__actions">
                                          <a
                                            onClick={(event) =>
                                              this.ShowHistory(
                                                event,
                                                interaction.idcdr,
                                                interaction.datarc
                                              )
                                            }
                                            className="modal__content__tabs__body__tab__result__body__actions__action"
                                          >
                                            <i className="material-icons">
                                              forum
                                            </i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          </Tooltippy>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </main>
              <footer className="modal__footer modal__footer--pull-right">
                {/* <a onClick={event => this.ShowContactDisplay(event, this.state.interactcontact)} className="modal__btn modal__btn-primary">Ver contato</a> */}
                <a
                  className="modal__btn modal__btn-secondary"
                  onClick={(event) =>
                    this.ExitModal(
                      event,
                      "modal__agenda-pf__cliente__interacoes"
                    )
                  }
                >
                  Voltar
                </a>
              </footer>
            </div>
          </div>
        </div>
        {/* Modal de Historico */}

        <div
          className="modal micromodal-slide"
          id="modal__historico-atendimento-contact-2"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__historico-atendimento__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__historico-atendimento__title"
                >
                  Interação
                </h2>
                <button
                  onClick={(event) => this.CloseHistory(event)}
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__historico-atendimento__content"
              >
                <div className="hist-atd__info">
                  <div className="hist-atd__info-items">
                    <p className="hist-atd__name  is-poppins">
                      {createJSON(ContactId.cliente)}
                    </p>
                    <i className="material-icons hist-atd__icon">
                      question_answer
                    </i>{" "}
                    <span className="hist-atd__info-text">
                      Total de{" "}
                      <span className="hist-atd__counter">
                        {this.state.totalhistory}
                      </span>{" "}
                      interações&#x28;s&#x29;
                    </span>
                  </div>
                  {(() => {
                    if (InfoUsers.permdownload === true) {
                      return (
                        <div className="hist-atd__info-pdf">
                          <a
                            onClick={() => this.exportPDFWithMethod(ContactId)}
                          >
                            <img src={ICONPDFEXPORT} />
                            Exportar PDF
                          </a>
                        </div>
                      );
                    }
                  })()}
                </div>
                <div className="hist-atd__ctrls">
                  <p className="hist-atd__text">Período</p>
                  <span className="hist-atd__span">De:</span>
                  <input
                    type="datetime-local"
                    ref={(input) => (this.datahistoryinitinteract = input)}
                    className="hist-atd__end"
                    id="hist_start_queue"
                  />
                  <span className="hist-atd__span">Até:</span>
                  <input
                    type="datetime-local"
                    ref={(input) => (this.datahistoryfiminteract = input)}
                    className="hist-atd__end"
                    id="hist_end_queue"
                  />
                  <button
                    className="hist-atd__search-btn"
                    onClick={this.SearchHistoryContact.bind(
                      this,
                      ContactId.telefone
                    )}
                  >
                    Filtrar
                  </button>
                </div>
                <div className="hist-atd__content">
                  <div
                    className={
                      this.state.showHistory
                        ? "hist-atd__search active"
                        : "hist-atd__search"
                    }
                  >
                    <span
                      onClick={(event) => this.handleKeyUp("less")}
                      className="material-icons hist-atd__search-icon"
                    >
                      expand_less
                    </span>
                    <span
                      onClick={(event) => this.handleKeyUp("more")}
                      className="material-icons hist-atd__search-icon"
                    >
                      expand_more
                    </span>
                    <input
                      onChange={(event) => this.GetTermText(event)}
                      type="text"
                      className="hist-atd__search-input"
                      id="campopesquisartexto"
                      placeholder="Pesquisar..."
                    />
                    <button
                      onClick={this.SearchInHistoryContact.bind(this)}
                      className="hist-atd__search-btn hist-atd__search-btn--two"
                    >
                      Concluir
                    </button>
                  </div>
                  <div className="hist-atd__channel-info">
                    <img
                      className="hist-atd__channel-info-icon"
                      style={{ display: "none" }}
                      src={WHATSAPP}
                      alt=""
                      width="20"
                      height="20"
                    />
                    <div className="hist-atd__channel-info-time">
                      Interações
                    </div>
                  </div>
                  <div
                    className="hist-atd__wrapper"
                    onScroll={this.handleScroll}
                  >
                    <div className="hist-atd__channel">
                      <div className="hist-atd__channel-chat active">
                        {this.state.history.map((history, index) => (
                          <div
                            key={index}
                            className={
                              history.agente === true
                                ? "message right"
                                : "message left"
                            }
                          >
                            {(() => {
                              dia = history.diaenvio;
                              mes = history.mesenvio;
                              ano = history.anoenvio;
                              mes = meses.indexOf(mes);
                              dia = dia + " de " + meses[mes - 1];
                              if (
                                ano < history.anoenvio ||
                                ano > history.anoenvio
                              )
                                dia = dia + " de " + history.anoenvio;
                              if (dia != auxdia) {
                                dia = dia;
                                auxdia = dia;
                              } else {
                                auxdia = dia;
                                dia = "";
                              }
                            })()}
                            <div id={history.id} className="time">
                              {dia}
                            </div>
                            <div
                              className="bubble"
                              id={"contact_" + history.id}
                            >
                              {(() => {
                                if (history.replyid > 0) {
                                  var text = "";
                                  var array = [];
                                  var posit = "";
                                  checkreply = true;

                                  array = this.state.history.filter(
                                    (msg) =>
                                      parseInt(msg.id) ===
                                      parseInt(history.replyid)
                                  );
                                  if (array.length !== 0 && array) {
                                    posit = array[0].author;
                                    if (array[0].mimetypeid !== 1) {
                                      var url = array[0].messagem;
                                      url = url.substring(
                                        url.lastIndexOf(".") + 1
                                      );
                                      switch (url.toLowerCase()) {
                                        case "jpeg":
                                        case "png":
                                        case "jpg": {
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={FOTO}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  Imagem
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "pdf":
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={DOC}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  PDF
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        case "xls":
                                        case "xlsx":
                                        case "xlsm":
                                        case "doc":
                                        case "docx":
                                        case "ppt":
                                        case "pptx": {
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={DOC}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  DOC
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "wav":
                                        case "mp3":
                                        case "ogg":
                                        case "mpeg": {
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={AUDIO}
                                                    alt=""
                                                    width="12"
                                                  />{" "}
                                                  Áudio
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "mp4": {
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={VIDEO}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  Vídeo
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                      }
                                    } else {
                                      text = array[0].messagem;
                                      if (text.length > 200)
                                        text = text.substr(0, 200) + "...";
                                      text = text.replace(/¿/gi, "\n");
                                      text = text.replace(/§/gi, "\r\n");
                                      return (
                                        <a href={"#contact_" + history.replyid}>
                                          <div className="reply-message active">
                                            <div className="reply-message__name">
                                              {posit === "Me"
                                                ? "Você"
                                                : createJSON(
                                                    this.state.cliente
                                                  )}
                                            </div>
                                            <div className="reply-message__text">
                                              {text}
                                            </div>
                                          </div>
                                        </a>
                                      );
                                    }
                                  }
                                }
                                //}
                              })()}

                              <div className="bubble-user-name">
                                {checkreply === false
                                  ? history.agente === false
                                    ? createJSON(this.state.cliente)
                                    : history.username
                                  : null}
                              </div>
                              <div className="text">
                                {(() => {
                                  let caption = history.caption;
                                  if (caption == "null" || caption == null) {
                                    caption = "";
                                  } else {
                                    caption = caption.replace(/\\n/g, "\r\n");
                                  }
                                  var positmessage1 = "";
                                  var positmessage2 = "";
                                  if (history.is_from_agent === true) {
                                    positmessage1 = " right";
                                  }
                                  checkreply = false;
                                  if (history.mimetypeid == "1") {
                                    var mensagem_tratada = tratarMSG(
                                      history.messagem
                                    );
                                    mensagem_tratada = mensagem_tratada.replace(
                                      /\\n/gi,
                                      "\r\n"
                                    );
                                    return (
                                      <div>
                                        <Highlighter
                                          highlightClassName="YourHighlightClass"
                                          searchWords={searchWords}
                                          autoEscape={true}
                                          textToHighlight={mensagem_tratada}
                                          sanitize={latinize}
                                        />
                                        <span className="text__end-spacing"></span>
                                      </div>
                                    );
                                  } else {
                                    if (history.mimetypeid == "2") {
                                      if (isJson(history.messagem) === true) {
                                        let json = JSON.parse(history.messagem);
                                        let options = json.options;
                                        let i = 1;
                                        var opcoes = [];
                                        for (i in options) {
                                          opcoes.push(
                                            i + " - " + options[i][1]
                                          );
                                        }
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={
                                                json.msg + " \r\n "
                                              }
                                              sanitize={latinize}
                                            />
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={opcoes.join(
                                                "  \r\n  "
                                              )}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={history.messagem}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      }
                                    } else if (history.mimetypeid == "30") {
                                      if (isJson(history.messagem) === true) {
                                        let json = JSON.parse(history.messagem);
                                        let options = json.options;
                                        let i = 1;
                                        var opcoes = [];
                                        for (i in options) {
                                          opcoes.push(
                                            i + " - " + options[i][1]
                                          );
                                        }
                                        if (json.MSG) {
                                          return (
                                            <div>
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={
                                                  json.MSG + " \r\n "
                                                }
                                                sanitize={latinize}
                                              />
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={opcoes.join(
                                                  "  \r\n  "
                                                )}
                                                sanitize={latinize}
                                              />
                                              <span className="text__end-spacing"></span>
                                            </div>
                                          );
                                        } else if (json.URL) {
                                          return (
                                            <div>
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={
                                                  json.URL + " \r\n "
                                                }
                                                sanitize={latinize}
                                              />
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={opcoes.join(
                                                  "  \r\n  "
                                                )}
                                                sanitize={latinize}
                                              />
                                              <span className="text__end-spacing"></span>
                                            </div>
                                          );
                                        }
                                      } else {
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={history.messagem}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      }
                                    } else if (
                                      history.mimetypeid == "3" ||
                                      history.mimetypeid == "4" ||
                                      history.mimetypeid == "5" ||
                                      history.mimetypeid >= "6"
                                    ) {
                                      let separador =
                                        history.messagem.split(".");
                                      switch (separador[1]) {
                                        case "jpeg":
                                        case "png":
                                        case "PNG":
                                        case "jpg":
                                          return (
                                            <div className="bubble-media">
                                              <div
                                                className="bubble-media__image"
                                                onClick={(e) =>
                                                  this.VerifierImage(
                                                    e,
                                                    connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem,
                                                    "history"
                                                  )
                                                }
                                              >
                                                {this.state.isOpen && (
                                                  <Lightbox
                                                    mainSrc={
                                                      this.state.urlimage
                                                    }
                                                    onCloseRequest={(e) =>
                                                      this.CloseImage(
                                                        e,
                                                        "history"
                                                      )
                                                    }
                                                  />
                                                )}
                                                <img
                                                  src={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    history.messagem
                                                  }
                                                  alt=""
                                                />
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={JPG}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "pdf":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={PDF}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "xls":
                                        case "xlsx":
                                        case "xlsm":
                                        case "doc":
                                        case "docx":
                                        case "ppt":
                                        case "pptx":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={XLS}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "wav":
                                        case "mp3":
                                        case "ogg":
                                        case "mpeg":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__playerBar">
                                                <audio controls>
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="audio/ogg"
                                                  />
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser.
                                                </audio>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={MP3}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "mp4":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__video">
                                                <video
                                                  className="bubble-media__video-frame"
                                                  controls
                                                >
                                                  <source
                                                    className="bubble-media__video-file"
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="video/mp4"
                                                  />
                                                  Seu navegador nao suporta esse
                                                  tipo de arquivo.
                                                </video>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={AVI}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        default:
                                          if (
                                            history.messagem.indexOf("https") >
                                              -1 &&
                                            history.messagem !== ""
                                          ) {
                                            if (
                                              parseInt(history.mimetypeid) ===
                                                16 ||
                                              parseInt(history.mimetypeid) ===
                                                41
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__video">
                                                    <video
                                                      className="bubble-media__video-frame"
                                                      controls
                                                    >
                                                      <source
                                                        className="bubble-media__video-file"
                                                        src={history.messagem}
                                                        type="video/mp4"
                                                      />
                                                      Seu navegador nao suporta
                                                      esse tipo de arquivo.
                                                    </video>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      {/* <img className="bubble-media__fileIcon" src={AVI} alt="" /> */}
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) === 1
                                            ) {
                                              var mensagem_tratada = tratarMSG(
                                                history.messagem
                                              );
                                              mensagem_tratada =
                                                mensagem_tratada.replace(
                                                  /\\n/gi,
                                                  "\r\n"
                                                );
                                              return (
                                                <div>
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={
                                                      mensagem_tratada
                                                    }
                                                    sanitize={latinize}
                                                  />
                                                  <span className="text__end-spacing"></span>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                5 ||
                                              parseInt(history.mimetypeid) ===
                                                7 ||
                                              parseInt(history.mimetypeid) ===
                                                8 ||
                                              parseInt(history.mimetypeid) ===
                                                9 ||
                                              parseInt(history.mimetypeid) ===
                                                10 ||
                                              parseInt(history.mimetypeid) ===
                                                11 ||
                                              parseInt(history.mimetypeid) ===
                                                12 ||
                                              parseInt(history.mimetypeid) ===
                                                13 ||
                                              parseInt(history.mimetypeid) ===
                                                14
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType"></span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                4 ||
                                              parseInt(history.mimetypeid) ===
                                                6 ||
                                              parseInt(history.mimetypeid) ===
                                                15 ||
                                              parseInt(history.mimetypeid) ===
                                                17 ||
                                              parseInt(history.mimetypeid) ===
                                                21 ||
                                              parseInt(history.mimetypeid) ===
                                                25 ||
                                              parseInt(history.mimetypeid) ===
                                                26 ||
                                              parseInt(history.mimetypeid) ===
                                                27 ||
                                              parseInt(history.mimetypeid) ===
                                                28 ||
                                              parseInt(history.mimetypeid) ===
                                                40
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__playerBar">
                                                    <audio controls>
                                                      <source
                                                        src={history.messagem}
                                                        type="audio/ogg"
                                                      />
                                                      <source
                                                        src={history.messagem}
                                                        type="audio/mpeg"
                                                      />
                                                      Your browser.
                                                    </audio>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      {/* <img className="bubble-media__fileIcon" src={MP3} alt="" /> */}
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                3 ||
                                              parseInt(history.mimetypeid) ===
                                                18 ||
                                              parseInt(history.mimetypeid) ===
                                                19 ||
                                              parseInt(history.mimetypeid) ===
                                                20 ||
                                              parseInt(history.mimetypeid) ===
                                                22 ||
                                              parseInt(history.mimetypeid) ===
                                                23 ||
                                              parseInt(history.mimetypeid) ===
                                                24
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div
                                                    className="bubble-media__image"
                                                    onClick={(e) =>
                                                      this.VerifierImage(
                                                        e,
                                                        history.messagem,
                                                        "history"
                                                      )
                                                    }
                                                  >
                                                    {this.state.isOpen && (
                                                      <Lightbox
                                                        mainSrc={
                                                          this.state.urlimage
                                                        }
                                                        onCloseRequest={(e) =>
                                                          this.CloseImage(
                                                            e,
                                                            "history"
                                                          )
                                                        }
                                                      />
                                                    )}
                                                    <img
                                                      src={history.messagem}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType"></span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          }
                                      }
                                    }
                                  }
                                })()}
                              </div>
                              <div className="text">
                                {(() => {
                                  let caption = history.caption;
                                  if (caption == "null" || caption == null) {
                                    caption = "";
                                  } else {
                                    caption = caption.replace(/\\n/g, "\r\n");
                                  }
                                  return caption;
                                })()}
                              </div>
                              <div className="bubble__info-content">
                                <div className="fav fav--inside fav--right">
                                  {/* <i className="material-icons fav-icon">star_border</i> */}
                                </div>
                                <div className="bubble__info-content__time">
                                  {history.horaenvio}
                                </div>
                                {(() => {
                                  if (history.agente === true) {
                                    if (parseInt(history.mon_type_id) !== 2) {
                                      if (history.dateerror !== null)
                                        return (
                                          <div
                                            className={
                                              "message-info message-info--error"
                                            }
                                          >
                                            <i className="material-icons">
                                              error
                                            </i>
                                          </div>
                                        );
                                      else if (history.dateread !== null)
                                        return (
                                          <div
                                            className={
                                              "message-info message-info--visto"
                                            }
                                          >
                                            <i className="material-icons">
                                              done_all
                                            </i>
                                          </div>
                                        );
                                      else if (history.datedelivered !== null)
                                        return (
                                          <div className={"message-info"}>
                                            <i className="material-icons">
                                              done_all
                                            </i>
                                          </div>
                                        );
                                      else
                                        return (
                                          <div className={"message-info"}>
                                            <i className="material-icons">
                                              done
                                            </i>
                                          </div>
                                        );
                                    } else {
                                      return (
                                        <div
                                          className={
                                            "message-info message-info--visto"
                                          }
                                        >
                                          <i className="material-icons">
                                            done_all
                                          </i>
                                        </div>
                                      );
                                    }
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </main>

              <button
                className="hist-atd__fab"
                onClick={this.SearchInHistoryContact.bind(this)}
              >
                <i className="material-icons">search</i>
              </button>

              <div className="modal__content__form__group modal__content__form__group--col-1">
                <a
                  onClick={(event) => this.CloseHistory(event)}
                  className="modal__content__form__group__button modal__content__form__group__button--text"
                  data-micromodal-close
                >
                  <i className="material-icons" data-micromodal-close>
                    arrow_back
                  </i>
                  Voltar
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            right: "-9999999999999999999999999px",
            top: 0,
          }}
        >
          <PDFExport
            ref={(component) => (this.pdfExportComponent = component)}
            paperSize="A4"
          >
            <PdfDocument
              history={this.state.history}
              cliente={ContactId.cliente}
              datapdfinit={this.state.dateinit}
              datapdfend={this.state.dateend}
              numero={ContactId.telefone}
            />
          </PDFExport>
        </div>
        {/* Fim do Modal de Historico */}
      </>
    );
  }
  exportPDFWithMethod = (ContactId) => {
    savePDF(ReactDOM.findDOMNode(this.pdfExportComponent), {
      paperSize: "A4",
      margin: 10,
      fileName: ContactId.cliente + "_" + ContactId.telefone + ".pdf",
    });
  };
  exportPDFWithComponent = () => {
    this.pdfExportComponent.save();
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InteractionsModal);
